// @flow
import type {
  NETWORK_CONNECTED_TYPE,
  NETWORK_DISCONNECTED_TYPE,
} from '../types/network';
import type {
  TEMPORARY_EVENT_ADDED_TYPE
} from '../types/temporaryEvents';
import * as types from '../types/network';
import * as temporalEventsTypes from '../types/temporaryEvents';

import { GROUP_NETWORK_BANNERS } from '../components/NetworkBanner';


export const connectNetwork = (): NETWORK_CONNECTED_TYPE => ({
  type: types.NETWORK_CONNECTED,
});

export const disconectNetwork = (): NETWORK_DISCONNECTED_TYPE => ({
  type: types.NETWORK_DISCONNECTED,
});

export const addBanner = (
  id,
  message,
  type,
  lifespan = false
): TEMPORARY_EVENT_ADDED_TYPE => ({
  type: temporalEventsTypes.TEMPORARY_EVENT_ADDED,
  payload: {
    id,
    lifespan,
    group: GROUP_NETWORK_BANNERS,
    data: {
      message,
      type,
    },
    active: !lifespan,
  }
});



// WEBPACK FOOTER //
// ./src/scripts/actions/network.js